import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "./Breadcrumb";
import Swal from "sweetalert2";
import { API_URL } from "..";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";

const EditPolicyPage = () => {
    const {id} = useParams();
  const [formData, setFormData] = useState({
    policyType: "",
    details: "",
  });
  const [error, setError] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  // Policy types for dropdown
  const policyTypes = [
    { value: "invoice-privacy", label: "Invoice Policy" },
    { value: "quote-privacy", label: "Quote Policy" }
  ];

  // React Quill toolbar configuration
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  // Handle dropdown change
  const handlePolicyTypeChange = (e) => {
    setFormData((prev) => ({ ...prev, policyType: e.target.value }));
    setError("");
  };

  // Handle React Quill change
  const handleEditorChange = (value) => {
    setFormData((prev) => ({ ...prev, details: value }));
    setError("");
  };

  // Validate form
  const fetchPolicies = async () => {
    try {
      const response = await fetch(`${API_URL}/api/user/policy/${id}`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (response.status === 200) {
       setFormData({
        policyType : data.policy.type,
        details: data.policy.details
       })
      } else {
        throw new Error(data.message || "Failed to fetch policies");
      }
    } catch (err) {
      console.error("Fetch policies error:", err);
    
     
    }
  };
  useEffect(()=>{
    fetchPolicies()
  },[])
  const validateForm = () => {
    if (!formData.policyType) return "Policy type is required";
    if (!formData.details.trim() || formData.details === "<p><br></p>")
      return "Policy details are required";
    return "";
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const formDataToSend = new FormData();
      const obj = {type:formData.policyType,details:formData.details};
      

      const response = await fetch(`${API_URL}/api/user/policy/${id}`, {
        method: "PUT",
        body: JSON.stringify(obj),
        headers:{
            'Content-Type' :'application/json',
            'Accept': '*/*'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Policy Updated",
          text: "Policy has been updated successfully",
        });
        
      } else {
        throw new Error(data.message || "Failed to update policy");
      }
    } catch (err) {
      console.error("Submit error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "Unable to update policy",
      });
    }
  };

  // Handle preview
  const handlePreview = () => {
    if (!formData.details.trim() || formData.details === "<p><br></p>") {
      setError("Please enter policy details to preview");
      return;
    }
    setShowPreview(true);
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      policyType: "",
      details: "",
    });
    setError("");
    setShowPreview(false);
  };

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Edit Policy" />

        <div className="card basic-data-table">
          <div className="card-header">
            <h5 className="card-title mb-0">Edit Policy</h5>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger mb-3">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Policy Type</label>
                <select
                  name="policyType"
                  value={formData.policyType}
                  onChange={handlePolicyTypeChange}
                  className="form-control"
                  required
                >
                  <option value="">Select Policy Type</option>
                  {policyTypes.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Policy Details</label>
                <ReactQuill
                  value={formData.details}
                  onChange={handleEditorChange}
                  modules={quillModules}
                  className="quill-editor"
                  theme="snow"
                />
              </div>
              <div className="d-flex gap-2">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ background: "#db6f2f", borderColor: "#db6f2f" }}
                >
                  Update Policy
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handlePreview}
                >
                  Preview
                </button>
              </div>
            </form>

            {/* Preview Modal */}
            {showPreview && (
              <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Policy Preview</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowPreview(false)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div
                        dangerouslySetInnerHTML={{ __html: formData.details }}
                        className="policy-preview"
                        style={{ padding: "20px", lineHeight: "1.6" }}
                      />
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowPreview(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default EditPolicyPage;